/**
 * VoucherSubsanarChip — Chip rojo que aparece cuando la reserva está
 * bloqueada por un voucher pendiente de subsanar.
 *
 * Backend: campo `voucher_pendiente_subsanar` (boolean) en `reservaciones`.
 * Se activa cuando la reserva registró un pago con método no-efectivo pero
 * NO tiene voucher válido asociado. Mientras está en TRUE:
 *   - No se puede editar la reserva
 *   - No se puede embarcar
 *   - No se pueden registrar pagos adicionales
 *   - Solo se permite subir el voucher (única acción habilitada)
 *
 * Al subir un voucher válido se limpia automáticamente el flag.
 *
 * Devuelve null si el flag es false — no ocupa espacio.
 */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

export default function VoucherSubsanarChip({ voucherPendienteSubsanar, size = 'small' }) {
  if (!voucherPendienteSubsanar) return null;

  return (
    <Tooltip
      arrow
      title="Reserva bloqueada: hay un pago registrado sin voucher válido. Sube el voucher desde el detalle para desbloquear todas las operaciones (editar, embarcar, cobrar)."
    >
      <Chip
        size={size}
        icon={<LockIcon sx={{ fontSize: '14px !important',
                              color: '#7f1d1d !important' }} />}
        label="Subsanar voucher"
        sx={{
          bgcolor: '#fee2e2', color: '#7f1d1d',
          fontWeight: 800, fontSize: 11, height: 22,
          border: '1px solid #fca5a5',
          '& .MuiChip-icon': { ml: 0.5 },
          '& .MuiChip-label': { pl: 0.5 },
          // Animación sutil para llamar la atención sin ser molesta
          animation: 'pulseVoucher 2s ease-in-out infinite',
          '@keyframes pulseVoucher': {
            '0%, 100%': { boxShadow: '0 0 0 0 rgba(220, 38, 38, 0)' },
            '50%':      { boxShadow: '0 0 0 3px rgba(220, 38, 38, 0.15)' },
          },
        }}
      />
    </Tooltip>
  );
}
